export const SQUAD_CONFIG = {
  DEFAULT_HANDOFF_RULES: '[]',
  DEBOUNCE_SAVE_MS: 2000,
  ICON_SIZE: 20,
  DEFAULT_AGENT_OPACITY: 0.5,
} as const;

export const SQUAD_MESSAGES = {
  CREATED_SUCCESS: 'adminMainPage.squad.messages.createdSuccess',
  CREATED_ERROR: 'adminMainPage.squad.messages.createdError',
  DELETED_SUCCESS: 'adminMainPage.squad.messages.deletedSuccess',
  DELETED_ERROR: 'adminMainPage.squad.messages.deletedError',
  SET_DEFAULT_SUCCESS: 'adminMainPage.squad.messages.setDefaultSuccess',
  SET_DEFAULT_ERROR: 'adminMainPage.squad.messages.setDefaultError',
  AGENT_DELETED_SUCCESS: 'adminMainPage.squad.messages.agentDeletedSuccess',
  AGENT_DELETED_ERROR: 'adminMainPage.squad.messages.agentDeletedError',
  HANDOFF_RULES_SAVED: 'adminMainPage.squad.messages.handoffRulesSavedAuto',
  HANDOFF_RULES_SAVE_FAILED: 'adminMainPage.squad.messages.handoffRulesSaveFailed',
  AGENT_TOOLS_SAVED: 'adminMainPage.squad.messages.agentToolsSaved',
  AGENT_TOOLS_SAVE_FAILED: 'adminMainPage.squad.messages.agentToolsSaveFailed',
} as const;

export const SQUAD_LABELS = {
  SQUAD_MODE: 'adminMainPage.squad.labels.squadMode',
  SINGLE_AGENT: 'adminMainPage.squad.labels.singleAgent',
} as const;

export const SQUAD_OPERATIONS = {
  SET_AS_DEFAULT: 'adminMainPage.operation.setAsDefault',
  EDIT: 'adminMainPage.operation.edit',
  DELETE: 'adminMainPage.operation.delete',
  CANCEL: 'adminMainPage.operation.cancel',
  MAKE_TEST_CALL: 'adminMainPage.operation.makeTestCall',
  ADVANCED_SETTINGS: 'adminMainPage.operation.advancedSettings',
} as const;

export const SQUAD_VALIDATION = {
  AT_LEAST_ONE_AGENT: 'adminMainPage.errors.atLeastOneAgentInSquad',
} as const;
